/*
  NOTE: THIS IS A TEMPORARY SOLUTION TO ALLOW FOLLOWING ON THE PROFILE PAGE
  UNTIL WE ARE ABLE TO IMPLEMENT THE NEW PROFILE EXPERIENCE. USING THIS COMPONENT WILL
  REQUIRE RUNNING THE APPLICATION WITH SSL IN DEVELOPMENT.
*/

import React from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import classNames from 'classnames';
import { UserConnection, UserConnectionActionType } from '@alltrails/shared/types/belay';
import { IdKey } from '@alltrails/shared/types/lists';
import { RequestState } from '@alltrails/shared/types/blazes';
import useFormatMessage from 'hooks/useFormatMessage';
import onUserActionClick from 'utils/community/userAction';
import COMMUNITY_CONNECT from '../communityConnectStrings.string';

type Props = {
  userConnection?: UserConnection;
  takeUserAction: (userActionKey: UserConnectionActionType) => void;
  className?: string;
  userId: IdKey;
};

const FollowButton = ({ userConnection, takeUserAction, className, userId }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { FOLLOW, UNFOLLOW, REQUESTED }
  } = useFormatMessage(COMMUNITY_CONNECT);

  if (!userConnection || !userConnection.actions) {
    return <></>;
  }

  const { follow, unfollow, retractRequest } = userConnection.actions;
  const title = follow ? FOLLOW : unfollow ? UNFOLLOW : REQUESTED;
  const { requestState } = follow || unfollow || retractRequest || {};
  const props = { loading: requestState === RequestState.Loading, className: classNames(className), text: title, testId: title };

  if (follow) {
    return (
      <Button
        {...props}
        onClick={() => onUserActionClick(UserConnectionActionType.Follow, userId, userConnection.user.id, takeUserAction)}
        size="sm"
        variant="primary"
      />
    );
  }

  if (unfollow) {
    return (
      <Button
        {...props}
        onClick={() => onUserActionClick(UserConnectionActionType.Unfollow, userId, userConnection.user.id, takeUserAction)}
        size="sm"
        variant="default"
      />
    );
  }

  if (retractRequest) {
    return (
      <Button
        {...props}
        onClick={() => onUserActionClick(UserConnectionActionType.RetractRequest, userId, userConnection.user.id, takeUserAction)}
        size="sm"
        variant="default"
      />
    );
  }

  return <></>;
};

export default FollowButton;
